import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Grid, Row, Col } from 'flexbox'
import SRPCard from 'components/SRPCard'
import styles from './styles'
import fixtureData from './fixtureData'

class LatestProperties extends PureComponent {
  static propTypes = {

  }

  static defaultProps = {

  }

  render() {
    return (
      <div className="latest-properties">
        <div className="latest-properties-title">
          Últimas propiedades destacadas
        </div>
        <Grid fluid style={{ maxWidth: '1140px' }}>
          <Row>
            <Col xs={12} md={8}>
              <SRPCard
                propertyData={fixtureData[0]}
              />
            </Col>
            <Col xs={12} md={4}>
              <SRPCard
                vertical
                propertyData={fixtureData[1]}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={4}>
              <SRPCard
                vertical
                propertyData={fixtureData[2]}
              />
            </Col>
            <Col xs={12} md={4}>
              <SRPCard
                vertical
                propertyData={fixtureData[3]}
              />
            </Col>
            <Col xs={12} md={4}>
              <SRPCard
                vertical
                propertyData={fixtureData[4]}
              />
            </Col>
          </Row>
        </Grid>
        <style jsx>{styles}</style>
      </div>
    )
  }
}

export default LatestProperties
